import { isNativeApp } from '@/globals/typescript/utils/pwaInstall'
import { reportError } from '@/globals/typescript/utils/reportError'

/**
 * Registers the installed-app service worker (sw/sw.ts, built to /sw.js).
 *
 * Skipped in dev (the worker only exists in a build, and would fight HMR), inside the Capacitor
 * shell (the native app already has its own install and offline story), and in browsers without
 * service-worker support. Registration waits for `load` so it never competes with first paint.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || isNativeApp() || !('serviceWorker' in navigator)) {
    return
  }

  const register = () => {
    navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      // Only the browser can see this — it never reaches lab-cloud.
      reportError(error, { operation: 'service-worker-register' })
    })
  }

  if (document.readyState === 'complete') {
    register()
  } else {
    window.addEventListener('load', register, { once: true })
  }
}
